<template>
	<div>
		<v-btn
			icon
			color="white"
			aria-label="Toggle search form"
			@click="toggleSearch"
		>
			<v-icon>mdi-magnify</v-icon>
		</v-btn>
		<v-menu
			v-model="searchActive"
			attach="header"
			:nudge-right="widgetX"
			:nudge-bottom="widgetY"
			:min-width="widgetWidth"
			:max-width="widgetWidth"
			:close-on-click="!filterActive"
			:close-on-content-click="false"
		>
			<!-- <template v-slot:activator="{ on }">
				<v-btn
					icon
					color="white"
					v-on="on"
				>
					<v-icon>mdi-magnify</v-icon>
				</v-btn>
			</template> -->
			<v-card tile>
				<v-btn-toggle
					v-model="txOptionSelected"
					background-color="grey lighten-1"
					color="white"
					class="d-lg-none"
					borderless
					light
					mandatory
					tile
				>
					<v-btn
						aria-label="Buy option"
						value="BUY"
						class="flex-grow-1"
						x-large
					>
						ขาย
					</v-btn>
					<v-btn
						aria-label="Rent option"
						value="RENT"
						class="flex-grow-1"
						x-large
					>
						เช่า
					</v-btn>
				</v-btn-toggle>
				<div class="d-flex">
					<v-list class="pa-0">
						<v-list-item-group
							v-model="txOptionSelected"
							color="white"
							class="fill-height overflow-hidden d-none d-lg-block grey lighten-2"
							mandatory
						>
							<v-list-item value="BUY">
								<v-list-item-content class="px-8">
									<v-list-item-title><b>ขาย</b></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item
								value="RENT"
								class="fill-height"
							>
								<v-list-item-content class="px-8 mb-auto">
									<v-list-item-title><b>เช่า</b></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>

					<div
						class="search flex-grow-1"
						:class="{ 'red-bottom-border': ['xs','sm','md'].includes(breakpoint) }"
					>
						<!-- <v-btn
							icon
							class="close-search"
							@click="searchActive = false"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn> -->
						<v-row>
							<!-- <v-col cols="12">

							</v-col> -->

							<v-col
								v-if="!noLocation"
								cols="12"
								class="py-1"
							>
								<!-- <v-btn
									ref="locationBtn"
									class="location-select btn-menu"
									height="100%"
									outlined
									fab
									x-small
									:dark="locationActive || useLocation"
									:color="locationActive || useLocation ? 'red' : 'black'"
									@click.native="locationShow"
								>
									<v-icon>mdi-send</v-icon>
								</v-btn> -->
								<v-menu
									v-model="locationActive"
									nudge-bottom="1"
									offset-y
									bottom
									right
									:position-x="locationX"
									:position-y="locationY"
									:close-on-content-click="false"
								>
									<v-card>
										<v-stepper v-model="locationStep">
											<v-stepper-items>
												<v-stepper-content
													class="location-select-panel pa-0"
													step="1"
												>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														@click="provinceClicked(null); locationActive = false;"
													>
														ทุกจังหวัด
													</v-btn>
													<v-divider />

													<div
														v-for="province in location"
														:key="province.p"
														:class="(provinceSelected !== province ? 'province-panel' : 'province-panel location-selected')"
														@click="provinceClicked(province)"
													>
														{{ province.n }}
													</div>
												</v-stepper-content>

												<v-stepper-content
													class="location-select-panel pa-0"
													step="2"
												>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														@click="locationStep = 1"
													>
														เลือกจังหวัดอื่น
													</v-btn>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														@click="districtClicked(null)"
													>
														อำเภอ / เขต ทั้งหมด
													</v-btn>
													<v-divider />

													<div
														v-for="district in provinceSelected ? provinceSelected.v : []"
														:key="district.d"
														@click="districtClicked(district)"
													>
														<div
															:class="(districtSelected.indexOf(district) < 0 ? 'district-panel' : 'district-panel location-selected')"
														>
															<v-checkbox
																color="white"
																hide-details
																:dark="districtSelected.indexOf(district) >= 0"
																:input-value="districtSelected.indexOf(district) >= 0"
																:label="district.n"
															/>
														</div>
														<div
															v-if="districtSelected.indexOf(district) > -1"
															class="sub-district-panel"
														>
															<div
																v-for="subDistrict in district.v"
																:key="subDistrict.s"
																:class="subDistrictSelected.indexOf(subDistrict) < 0 ? 'location-options' : 'location-options location-selected'"
																@click.stop="subDistrictClicked(subDistrict)"
															>
																<input
																	type="checkbox"
																	:checked="subDistrictSelected.indexOf(subDistrict) >= 0"
																> {{ subDistrict.n }}
															</div>
														</div>
													</div>
												</v-stepper-content>
											</v-stepper-items>
										</v-stepper>
									</v-card>
								</v-menu>

								<label><b>คำค้นหา</b></label>
								<v-combobox
									v-model="locationQueryText"
									:items="locationAcItems"
									:loading="locationAcLoading"
									:search-input.sync="locationText"
									:menu-props="{ maxWidth: 400 }"
									:hide-no-data="useLocation || locationActive"
									no-filter
									solo
									flat
									dense
									color="red"
									heights="36"
									class="location-text-field mt-1"
									label="ชื่อโครงการ หรือ ทำเลที่ตั้ง"
									item-text="name"
									item-value="name"
									append-icon=""
									@keydownss.native="locationInputQuery"
									@focus="acQuery(locationText)"
								>
									<template
										v-if="(locationText || '').trim() === ''"
										v-slot:no-data
									>
										<v-list-item @click="locationShow">
											<v-list-item-title>
												<div style="color: red;">
													เลือกจังหวัด อำเภอ ตำบล
												</div>
											</v-list-item-title>
										</v-list-item>
									</template>
									<template v-slot:item="{ parent, item }">
										<template v-if="typeof item !== 'object'">
											<v-list-item-content v-text="item" />
										</template>
										<template v-else>
											<v-list-item-content @click="locationInputQuery">
												<!-- eslint-disable vue/no-v-html -->
												<v-list-item-title v-html="filteredText(parent.searchInput, item.name)" />
												<v-list-item-subtitle v-html="filteredText(parent.searchInput, item.address)" />
												<!-- eslint-enable vue/no-v-html -->
											</v-list-item-content>
											<v-list-item-action>{{ item.category }}</v-list-item-action>
										</template>
									</template>
								</v-combobox>
							</v-col>

							<v-col
								cols="12"
								lg="4"
								class="py-1"
							>
								<label><b>ประเภทอสังหาริมทรัพย์</b></label>
								<v-btn
									ref="useForBtn"
									outlined
									tile
									width="100%"
									height="46"
									class="btn-menu text-left mt-1 px-2"
									:title="useForText"
									@click="useForShow"
								>
									<v-row no-gutters>
										<v-col
											class="flex-grow-1"
											style="width: 0;"
										>
											{{ useForText }}
										</v-col>
										<v-col class="flex-grow-0 flex-shrink-1">
											<v-icon color="grey lighten-1">
												mdi-menu-swap-outline
											</v-icon>
										</v-col>
									</v-row>
								</v-btn>
								<v-menu
									v-model="useForActive"
									nudge-bottom="1"
									offset-y
									bottom
									right
									:position-x="useForX"
									:position-y="useForY"
									:close-on-content-click="false"
								>
									<v-card>
										<v-tabs
											v-model="useForTab"
											color="red"
										>
											<v-tab
												href="#ALL"
												@click="useForVal = 'ALL'"
											>
												ทุกประเภท
											</v-tab>
											<v-tab
												href="#REST"
												@click="useForVal = 'REST'"
											>
												ที่อยู่อาศัย
											</v-tab>
											<v-tab
												href="#COMMERCIAL"
												@click="useForVal = 'COMMERCIAL'"
											>
												เชิงพาณิชย์
											</v-tab>
										</v-tabs>

										<v-tabs-items v-model="useForTab">
											<v-tab-item
												value="ALL"
												class="pt-2 black--text"
											>
												<div
													v-for="item in useForRestItems"
													:key="'ALL_' + item.value"
												>
													<v-checkbox
														v-model="useForSelected"
														class="px-4 pb-3"
														color="red"
														:label="item.text"
														:value="item.value"
														hide-details
														dense
													/>
												</div>

												<div
													v-for="item in useForCommercialItems"
													:key="'ALL_' + item.value"
												>
													<v-checkbox
														v-model="useForSelected"
														class="px-4 pb-3"
														color="red"
														:label="item.text"
														:value="item.value"
														hide-details
														dense
													/>
												</div>
											</v-tab-item>

											<v-tab-item value="REST">
												<div
													v-for="item in useForRestItems"
													:key="item.value"
													:class="item.value === useForVal ? 'bgGrey' : ''"
												>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														@click="useForVal = item.value; useForActive = false;"
													>
														{{ item.text }}
													</v-btn>
												</div>
											</v-tab-item>

											<v-tab-item value="COMMERCIAL">
												<div
													v-for="item in useForCommercialItems"
													:key="item.value"
													:class="item.value === useForVal ? 'bgGrey' : ''"
												>
													<v-btn
														:value="item.value"
														text
														tile
														width="100%"
														class="justify-start"
														@click="useForVal = item.value; useForActive = false;"
													>
														{{ item.text }}
													</v-btn>
												</div>
											</v-tab-item>
										</v-tabs-items>
									</v-card>
								</v-menu>
							</v-col>

							<v-col
								v-if="!noLocation"
								cols="12"
								lg="4"
								class="py-1"
							>
								<label><b>จังหวัด</b></label>
								<v-btn
									ref="locationBtn"
									outlined
									tile
									width="100%"
									height="46"
									class="btn-menu text-left mt-1 px-2"
									:title="refLocationText"
									@click="locationShow"
								>
									<v-row no-gutters>
										<v-col
											class="flex-grow-1"
											style="width: 0;"
										>
											{{ refLocationText }}
										</v-col>
										<v-col class="flex-grow-0 flex-shrink-1">
											<v-icon color="grey lighten-1">
												mdi-menu-swap-outline
											</v-icon>
										</v-col>
									</v-row>
								</v-btn>
							</v-col>

							<v-col
								cols="12"
								lg="4"
								class="py-1"
							>
								<label><b>ช่วงราคา</b></label>
								<v-btn
									ref="priceBtn"
									outlined
									tile
									width="100%"
									height="46"
									class="btn-menu text-left mt-1 px-2"
									:title="priceText"
									@click="priceShow"
								>
									<v-row no-gutters>
										<v-col
											class="flex-grow-1"
											style="width: 0;"
										>
											{{ priceText }}
										</v-col>
										<v-col class="flex-grow-0 flex-shrink-1">
											<v-icon color="grey lighten-1">
												mdi-menu-swap-outline
											</v-icon>
										</v-col>
									</v-row>
								</v-btn>
								<v-menu
									v-model="priceActive"
									nudge-bottom="1"
									offset-y
									bottom
									right
									:position-x="priceX"
									:position-y="priceY"
									:close-on-content-click="false"
								>
									<v-card class="price-options">
										<v-row
											no-gutters
											class="flex-nowrap"
										>
											<v-text-field
												v-model="priceMin"
												placeholder="ต่ำสุด"
												dense
												class="input-center flex-grow-1"
												@focus="hideMinPrice = false"
											/>
											<div class="flex-grow-0">
												-
											</div>
											<v-text-field
												v-model="priceMax"
												placeholder="สูงสุด"
												dense
												class="input-center flex-grow-1"
												@focus="hideMinPrice = true"
											/>
										</v-row>

										<div :class="hideMinPrice ? 'd-none' : ''">
											<div>
												<v-btn
													text
													tile
													width="100%"
													class="justify-start"
													@click="priceMin = ''; hideMinPrice = true;"
												>
													ไม่ระบุ
												</v-btn>
											</div>
											<v-divider />
											<div
												v-for="price in priceItems"
												:key="'min-' + price"
												:class="{'bgGrey': price.toString() === priceMin.toString(), 'd-none': txOptionSelected !== 'RENT' && price < 500000}"
											>
												<v-btn
													text
													tile
													width="100%"
													class="justify-start"
													:disabled="priceMax != '' && price > priceMax"
													@click="priceMin = price; hideMinPrice = true;"
												>
													{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
												</v-btn>
											</div>
										</div>

										<div>
											<div>
												<v-btn
													text
													tile
													width="100%"
													class="justify-end"
													@click="priceMax = ''; priceActive = false;"
												>
													ไม่ระบุ
												</v-btn>
											</div>
											<v-divider />
											<div
												v-for="price in priceItems"
												:key="'max-' + price"
												:class="{'bgGrey': price.toString() === priceMax.toString(), 'd-none': txOptionSelected !== 'RENT' && price < 500000}"
											>
												<v-btn
													text
													tile
													width="100%"
													class="justify-end"
													:disabled="price < priceMin"
													@click="priceMax = price; priceActive = false;"
												>
													{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
												</v-btn>
											</div>
										</div>
									</v-card>
								</v-menu>
							</v-col>

							<v-col
								cols="12"
								class="d-flex d-md-none mt-4 mt-lg-2"
							>
								<v-btn
									ref="filterBtnMobile"
									aria-label="Toggle filter options"
									color="grey lighten-1"
									depressed
									light
									tile
									width="75"
									class="filter flex-grow-1"
									@click="(event) => filterShow(event, 'filterBtnMobile')"
								>
									ตัวกรอง
								</v-btn>
								<v-btn
									class="flex-grow-1"
									aria-label="Clear search criteria"
									color="grey lighten-2"
									depressed
									light
									tile
									@click="clearCiteria"
								>
									ล้างข้อมูล
								</v-btn>
							</v-col>

							<v-col
								cols="12"
								class="d-flex pt-0 mt-lg-2"
							>
								<v-btn
									ref="filterBtn"
									aria-label="Toggle filter options"
									color="grey lighten-1"
									depressed
									light
									tile
									width="75"
									class="filter d-none d-md-block"
									@click="(event) => filterShow(event, 'filterBtn')"
								>
									ตัวกรอง
								</v-btn>
								<v-btn
									aria-label="Clear search criteria"
									color="grey lighten-2"
									class="d-none d-md-block"
									depressed
									tile
									@click="clearCiteria"
								>
									ล้างข้อมูล
								</v-btn>
								<v-btn
									aria-label="Submit search"
									class="btn-red-gradient white--text flex-grow-1 flex-lg-grow-0"
									depressed
									tile
									@click="searchActive=false; search();"
								>
									ค้นหา
								</v-btn>
								<v-btn
									aria-label="Submit search"
									class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
									depressed
									tile
									@click="searchActive=false; search();"
								>
									<v-icon>
										mdi-arrow-right
									</v-icon>
								</v-btn>
							</v-col>
							<!-- </v-row>
							</v-col> -->
						</v-row>
					</div>
				</div>
			</v-card>
		</v-menu>

		<v-menu
			v-model="filterActive"
			nudge-bottom="1"
			offset-y
			bottom
			right
			max-width="700"
			:position-x="filterX"
			:position-y="filterY"
			:close-on-content-click="false"
		>
			<!-- <template v-slot:activator="{ on }">
				<v-btn
					tile
					class="filter"
					v-on="on"
				>
					ตัวกรอง
				</v-btn>
			</template> -->
			<v-card class="dropdownSearch">
				<v-row class="px-3">
					<v-col
						cols="6"
						class="pb-0"
					>
						<v-text-field
							v-model="bedroomCount"
							type="number"
							label="ห้องนอน"
							outlined
							dense
							tile
							class="textField text-center"
							prepend-icon="mdi-minus"
							append-outer-icon="mdi-plus"
							@click:prepend="--bedroomCount; numberOptionChanged(1, 99, 'bedroomCount');"
							@click:append-outer="++bedroomCount; numberOptionChanged(1, 99, 'bedroomCount')"
							@change="numberOptionChanged(1, 99, 'bedroomCount')"
						/>
					</v-col>

					<v-col
						cols="6"
						class="pb-0"
					>
						<v-text-field
							v-model="toiletCount"
							type="number"
							label="ห้องน้ำ"
							outlined
							dense
							tile
							class="textField text-center"
							prepend-icon="mdi-minus"
							append-outer-icon="mdi-plus"
							@click:prepend="--toiletCount; numberOptionChanged(1, 99, 'toiletCount');"
							@click:append-outer="++toiletCount; numberOptionChanged(1, 99, 'toiletCount')"
							@change="numberOptionChanged(1, 99, 'toiletCount')"
						/>
					</v-col>

					<v-col
						cols="6"
						class="pb-0"
					>
						<v-text-field
							v-model="garageCount"
							type="number"
							label="ที่จอดรถ"
							outlined
							dense
							tile
							class="textField text-center"
							prepend-icon="mdi-minus"
							append-outer-icon="mdi-plus"
							@click:prepend="--garageCount; numberOptionChanged(1, 99, 'garageCount');"
							@click:append-outer="++garageCount; numberOptionChanged(1, 99, 'garageCount')"
							@change="numberOptionChanged(1, 99, 'garageCount')"
						/>
					</v-col>

					<v-col
						cols="6"
						class="pb-0"
					>
						<v-text-field
							v-model="floor"
							type="number"
							label="ชั้นที่ (หรือสูงกว่า) ห้องชุด"
							outlined
							dense
							tile
							class="textField text-center"
							prepend-icon="mdi-minus"
							append-outer-icon="mdi-plus"
							@click:prepend="--floor; numberOptionChanged(1, 300, 'floor');"
							@click:append-outer="++floor; numberOptionChanged(1, 300, 'floor')"
							@change="numberOptionChanged(1, 300, 'floor')"
						/>
					</v-col>

					<v-col
						cols="6"
						class="pb-0"
					>
						<v-select
							v-model="propertyDirectionSelected"
							solo
							reverse
							append-icon=""
							:menu-props="{ offsetY: true, closeOnContentClick: true }"
							:items="propertyDirection"
							:value="null"
							suffix="ทิศของทรัพย์"
						/>
					</v-col>

					<!--v-col
						cols="6"
						class="pb-0"
					>
						<v-menu
							v-model="usefulSpaceActive"
							nudge-bottom="1"
							offset-y
							bottom
							left
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ on }">
								<v-btn
									width="100%"
									height="40"
									color="white"
									class="btn-menu text-left text-lowercase px-3"
									:title="usefulSpaceText"
									v-on="on"
								>
									<v-row no-gutters>
										<div>ขนาดพื้นที่ใช้สอย</div>
										<v-spacer />
										<div>{{ usefulSpaceText }}</div>
									</v-row>
								</v-btn>
							</template>
							<v-card class="price-options">
								<v-row no-gutters>
									<v-text-field
										v-model="usefulSpaceMin"
										placeholder="ต่ำสุด"
										dense
										class="input-center"
										@focus="hideMinUseful = false"
									/>
									<div>-</div>
									<v-text-field
										v-model="usefulSpaceMax"
										placeholder="สูงสุด"
										dense
										class="input-center"
										@focus="hideMinUseful = true"
									/>
								</v-row>

								<div :class="hideMinUseful ? 'd-none' : ''">
									<div>
										<v-btn
											text
											tile
											width="100%"
											class="justify-start text-lowercase"
											@click="usefulSpaceMin = ''; hideMinUseful = true;"
										>
											ไม่ระบุ
										</v-btn>
									</div>
									<v-divider />
									<div
										v-for="usefulSpace in usefulSpaceItems"
										:key="'min-' + usefulSpace"
										:class="usefulSpace.toString() === usefulSpaceMin.toString() ? 'bgGrey' : ''"
									>
										<v-btn
											text
											tile
											width="100%"
											class="justify-start text-lowercase"
											:disabled="usefulSpaceMax != '' && usefulSpace > usefulSpaceMax"
											@click="usefulSpaceMin = usefulSpace; hideMinUseful = true;"
										>
											{{ new Intl.NumberFormat('th-TH').format(usefulSpace) }}m²
										</v-btn>
									</div>
								</div>

								<div>
									<div>
										<v-btn
											text
											tile
											width="100%"
											class="justify-end text-lowercase"
											@click="usefulSpaceMax = ''; usefulSpaceActive = false;"
										>
											ไม่ระบุ
										</v-btn>
									</div>
									<v-divider />
									<div
										v-for="usefulSpace in usefulSpaceItems"
										:key="'max-' + usefulSpace"
										:class="usefulSpace.toString() === usefulSpaceMax.toString() ? 'bgGrey' : ''"
									>
										<v-btn
											text
											tile
											width="100%"
											class="justify-end text-lowercase"
											:disabled="usefulSpace < usefulSpaceMin"
											@click="usefulSpaceMax = usefulSpace; usefulSpaceActive = false;"
										>
											{{ new Intl.NumberFormat('th-TH').format(usefulSpace) }}m²
										</v-btn>
									</div>
								</div>
							</v-card>
						</v-menu>
					</v-col-->

					<!--v-col
						cols="6"
						class="pb-0"
					>
						<v-menu
							v-model="areaSpaceActive"
							nudge-bottom="1"
							offset-y
							bottom
							left
							:close-on-content-click="false"
						>
							<template v-slot:activator="{ on }">
								<v-btn
									width="100%"
									height="40"
									color="white"
									class="btn-menu text-left text-lowercase px-3"
									:title="areaSpaceText"
									v-on="on"
								>
									<v-row no-gutters>
										<div>ขนาดที่ดิน</div>
										<v-spacer />
										<div>{{ areaSpaceText }}</div>
									</v-row>
								</v-btn>
							</template>
							<v-card class="price-options">
								<v-row no-gutters>
									<v-text-field
										v-model="areaSpaceMin"
										placeholder="ต่ำสุด"
										dense
										class="input-center"
										@focus="hideMinArea = false"
									/>
									<div>-</div>
									<v-text-field
										v-model="areaSpaceMax"
										placeholder="สูงสุด"
										dense
										class="input-center"
										@focus="hideMinArea = true"
									/>
								</v-row>

								<div :class="hideMinArea ? 'd-none' : ''">
									<div>
										<v-btn
											text
											tile
											width="100%"
											class="justify-start text-lowercase"
											@click="areaSpaceMin = ''; hideMinArea = true;"
										>
											ไม่ระบุ
										</v-btn>
									</div>
									<v-divider />
									<div
										v-for="areaSpace in areaSpaceItems"
										:key="'min-' + areaSpace"
										:class="areaSpace.toString() === areaSpaceMin.toString() ? 'bgGrey' : ''"
									>
										<v-btn
											text
											tile
											width="100%"
											class="justify-start text-lowercase"
											:disabled="areaSpaceMax != '' && areaSpace > areaSpaceMax"
											@click="areaSpaceMin = areaSpace; hideMinArea = true;"
										>
											{{ new Intl.NumberFormat('th-TH').format(areaSpace) }}m²
										</v-btn>
									</div>
								</div>

								<div>
									<div>
										<v-btn
											text
											tile
											width="100%"
											class="justify-end text-lowercase"
											@click="areaSpaceMax = ''; areaSpaceActive = false;"
										>
											ไม่ระบุ
										</v-btn>
									</div>
									<v-divider />
									<div
										v-for="areaSpace in areaSpaceItems"
										:key="'max-' + areaSpace"
										:class="areaSpace.toString() === areaSpaceMax.toString() ? 'bgGrey' : ''"
									>
										<v-btn
											text
											tile
											width="100%"
											class="justify-end text-lowercase"
											:disabled="areaSpace < areaSpaceMin"
											@click="areaSpaceMax = areaSpace; areaSpaceActive = false;"
										>
											{{ new Intl.NumberFormat('th-TH').format(areaSpace) }}m²
										</v-btn>
									</div>
								</div>
							</v-card>
						</v-menu>
					</v-col-->

					<v-col
						cols="6"
						class="pb-0"
					>
						<v-select
							v-model="announceTimeSelected"
							solo
							reverse
							append-icon=""
							:menu-props="{ offsetY: true, closeOnContentClick: true }"
							:items="announceTime"
							:value="null"
							suffix="ประกาศเมื่อ"
						/>
					</v-col>

					<v-col
						cols="12"
						class="d-flex align-end"
					>
						<v-menu
							ref="datePickerMenu"
							v-model="datePickerMenu"
							:close-on-content-click="false"
							transition="scale-transition"
							min-width="auto"
							offset-y
							right
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									aria-label="Toggle date picker"
									icon
									small
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small>
										mdi-calendar
									</v-icon>
								</v-btn>
							</template>
							<v-date-picker
								v-model="datePick"
								color="red"
								no-title
								scrollable
								@input="datePickerMenu = false"
							/>
						</v-menu>
						<div
							v-if="datePick"
							class="ml-2 mb-1"
						>
							ประกาศเมื่อวันที่ {{ datePick }}
						</div>

						<v-btn
							aria-label="Clear search criteria"
							class="ml-auto"
							color="grey lighten-2"
							depressed
							light
							tile
							@click="clearCiteria"
						>
							ล้างข้อมูล
						</v-btn>
						<v-btn
							aria-label="Submit search"
							class="red darken-4 white--text"
							depressed
							light
							tile
							@click="filterActive=false; search();"
						>
							ค้นหา
						</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-menu>
	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
const configSearch = require('~/plugins/config-search')

export default {
	props: {
		params: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			timer: null,

			searching: false,
			query: {},
			searchActive: false,
			widgetX: 0,
			widgetY: 0,

			fav: true,
			menu: false,
			hints: true,

			garageCount: '',
			bedroomCount: '',
			toiletCount: '',
			floor: '',

			/**
			 * More filter
			 */
			filterX: 0,
			filterY: 0,
			filterActive: false,

			/**
			 * Location options
			 */
			locationX: 0,
			locationY: 0,
			locationActive: false,
			useLocation: false,
			locationStep: 1,
			provinceSelected: null,
			districtSelected: [],
			subDistrictSelected: [],
			locationText: '',

			/**
			 * Location AC
			 */
			locationQueryText: '',
			locationAcItems: [],
			locationAcLoading: false,
			refLocationText: 'ทุกจังหวัด',

			/**
			 * Property tx options
			 */
			txOptionSelected: 'BUY',
			txOption: configSearch.txOption,

			/**
			 * 'Use for' options
			 */
			useForX: 0,
			useForY: 0,
			useForActive: false,
			useForTab: 'ALL',
			useForVal: 'ALL',
			useForSelected: [
				// ...configSearch.useForRestItems.map(item => item.value),
				// ...configSearch.useForCommercialItems.map(item => item.value)
			],
			useForRestItems: configSearch.useForRestItems,
			useForCommercialItems: configSearch.useForCommercialItems,

			/**
			 * Price options
			 */
			priceX: 0,
			priceY: 0,
			hideMinPrice: false,
			priceActive: false,
			priceMin: '',
			priceMax: '',
			priceItems: configSearch.priceItems,

			/**
			 * More filter: Announce time
			 */
			announceTimeSelected: null,
			announceTime: configSearch.announceTime,

			/**
			 * More filter: Useful space size
			 */
			hideMinUseful: false,
			usefulSpaceActive: false,
			usefulSpaceMin: '',
			usefulSpaceMax: '',
			usefulSpaceItems: configSearch.usefulSpaceItems,

			/**
			 * More filter: Area space size
			 */
			hideMinArea: false,
			areaSpaceActive: false,
			areaSpaceMin: '',
			areaSpaceMax: '',
			areaSpaceItems: configSearch.areaSpaceItems,

			/**
			 * More filter: Property direction
			 */
			propertyDirectionSelected: null,
			propertyDirection: configSearch.propertyDirection,

			/**
			 * More filter: Created date
			 */
			datePickerMenu: false,
			datePick: null,

			paramMap: {
				locationText: 'text',
				provinceSelected: 'province',
				districtSelected: 'district',
				subDistrictSelected: 'sub_district',
				txOptionSelected: 'tx',
				useForVal: 'market',
				priceMin: 'minprice',
				priceMax: 'maxprice',
				bedroomCount: 'minbeds',
				toiletCount: 'minbath',
				garageCount: 'mingarage',
				floor: 'floor',
				propertyDirectionSelected: 'direction',
				usefulSpaceMin: 'minsize',
				usefulSpaceMax: 'maxsize',
				areaSpaceMin: 'minlandsize',
				areaSpaceMax: 'maxlandsize',
				announceTimeSelected: 'latest',
				datePick: 'published_date'
			}
		}
	},

	computed: {

		...mapGetters({
			location: 'location',
			searchToggle: 'page/searchToggle'
		}),

		breakpoint () {
			return this.$vuetify.breakpoint.name
		},

		widgetWidth () {
			return ['xl','lg'].includes(this.breakpoint) ? 1161 : this.breakpoint === 'md' ? 876 : '100%'
		},

		noLocation () {
			return this.$route.path === '/map-search'
		},

		/*
		refLocationText () {
			let text = 'ไม่ระบุ'
			if (typeof this.locationQueryText === 'string' && this.provinceSelected) {
				text = this.locationQueryText
			} else if (typeof this.locationQueryText === 'object') {
				if (['province', 'district', 'subdistrict'].indexOf(this.locationQueryText?.type) !== -1) {
					text = this.locationQueryText.name
				}
			}

			return text
		},
		*/

		priceText () {
			let text = 'ไม่ระบุ'
			if(this.priceMin === '') {
				text = 'สูงสุด '
				if(this.priceMax === '') {
					text = 'ไม่จำกัดราคา'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.priceMin)
				if(this.priceMax === '') {
					text = 'เริ่มต้น ' + text + ' บาท'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			}

			return text
		},

		useForText () {
			let text = 'ไม่ระบุ'
			if (this.useForVal === 'REST') {
				text = 'ที่อยู่อาศัย'
			} else if (this.useForVal === 'COMMERCIAL') {
				text = 'เชิงพาณิชย์'
			} else if (this.useForVal === 'ALL') {
				if (this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length) && this.useForSelected.length > 0) {
					text = `เลือก ${this.useForSelected.length} ประเภท`
				}
			} else {
				for (let item of [...this.useForRestItems, ...this.useForCommercialItems]) {
					if (this.useForVal === item.value) {
						text = item.text
						break
					}
				}
			}

			return text
		},

		usefulSpaceText () {
			let text = ''
			if(this.usefulSpaceMin === '') {
				text = 'สูงสุด '
				if(this.usefulSpaceMax === '') {
					text = 'ไม่ระบุ'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.usefulSpaceMax) + 'm²'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.usefulSpaceMin)
				if(this.usefulSpaceMax === '') {
					text = 'ไม่น้อยกว่า ' + text + 'm²'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.usefulSpaceMax) + 'm²'
				}
			}

			return text
		},

		areaSpaceText () {
			let text = ''
			if(this.areaSpaceMin === '') {
				text = 'สูงสุด '
				if(this.areaSpaceMax === '') {
					text = 'ไม่ระบุ'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.areaSpaceMax) + 'm²'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.areaSpaceMin)
				if(this.areaSpaceMax === '') {
					text = 'ไม่น้อยกว่า ' + text + 'm²'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.areaSpaceMax) + 'm²'
				}
			}

			return text
		}
	},

	watch: {
		locationText (newVal) {
			this.acQuery(newVal)
		},

		/*
		useForSelected (newVal) {
			if (newVal.length === 0) {
				this.useForSelected = [
					...this.useForRestItems.map(item => item.value),
					...this.useForCommercialItems.map(item => item.value)
				]
			}
		},
		*/

		searchToggle () {
			this.searchActive = true
		},

		params () {
			// Ordering param is outside this component
			this.query.order = this.params.order
		},

		$route (newVal) {
			if (newVal.path === '/search' && !this.searching) {
				this.initCriteria({ ...newVal.query })
			} else if (this.searching) {
				this.searching = false
			}
		}
	},

	mounted () {
		// Need to extract (or clone) object (else it will reference to passing var)
		this.initCriteria({ ...this.params })
	},

	methods: {
		...mapActions({
			locationQuery: 'property/locationQuery'
		}),

		initCriteria (params = {}) {
			if (params) {
				this.query = params
			}

			let key, param, p, d
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this.query[param]) {
					if (key === 'provinceSelected') {
						p = this.location.find(p => p.p.toString() === this.query[param].toString())
						this[key] = p
						this.useLocation = true
					} else if (p && key === 'districtSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						d = p.v.filter(d => this.query[param].findIndex(x => x.toString() === d.d.toString()) > -1)
						this[key] = d
					} else if (p && d && key === 'subDistrictSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						this[key] = []
						for (let x of d) {
							this[key].push(...x.v.filter(s => this.query[param].findIndex(v => v.toString() === s.s.toString()) >= 0))
						}
					} else if (key === 'locationText') {
						if(!p) {
							// this[key] = this.query[param]
							if (this.query['type']) {
								this.locationQueryText = {
									name: this.query[param],
									type: this.query['type']
								}
							} else {
								this.locationQueryText = this.query[param] || ''
							}
						}
					} else {
						this[key] = this.query[param]
					}
				} else if (key === 'useForVal') {
					this[key] = 'ALL'
				} else if (key === 'txOptionSelected') {
					this[key] = 'BUY'
				}
			}

			if (d) {
				this.locationStep = 2
			}
			if (p) {
				this.locationTextChange()
			}

			// Check for active 'use-for' tab
			if (this.useForVal === 'REST' || this.useForRestItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'REST'
			} else if (this.useForVal === 'COMMERCIAL' || this.useForCommercialItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'COMMERCIAL'
			} else {
				if (this.query['market_selected']) {
					this.useForTab = 'ALL'
					if (typeof this.query['market_selected'] === 'string') {
						this.useForSelected = [ this.query['market_selected'] ]
					} else {
						this.useForSelected = this.query['market_selected']
					}
				} else {
					this.useForSelected = [
						// ...this.useForRestItems.map(item => item.value),
						// ...this.useForCommercialItems.map(item => item.value)
					]
				}
			}
		},

		filterShow (event, ref) {
			event.preventDefault()
			let rect = this.$refs[ref].$el.getBoundingClientRect()
			this.filterActive = false
			this.filterX = rect.left
			this.filterY = rect.bottom
			this.$nextTick(() => {
				this.filterActive = true
			})
		},

		filteredText (search, text) {
			if (text) {
				return text.split(search).join(`<span class="highlight">${search}</span>`)
			}
			return ''
		},

		acQuery (text) {
			if (!this.locationActive) {
				this.locationAcItems = []
				if (text && text.length > 2) {

					this.locationAcLoading = true

					// Delay before query
					if (this.timer) {
						clearTimeout(this.timer)
					}
					this.timer = setTimeout(() => {
						this.timer = null
						this.locationQuery(text).then(list => {
							this.locationAcItems = list
						}).catch(err => {
							console.log(err)
						}).finally(() => {
							this.locationAcLoading = false
						})
					}, 1000)
				}
			}
		},

		search () {
			let key, param
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this[key]) {
					if (Array.isArray(this[key]) && this[key].length === 0) {
						delete this.query[param]
					} else {
						if (key === 'txOptionSelected' && this[key] === 'ALL') {
							delete this.query[param]
						} else if (key === 'provinceSelected') {
							this.query[param] = this[key].p
						} else if (key === 'districtSelected') {
							this.query[param] = this[key].map(d => d.d)
						} else if (key === 'subDistrictSelected') {
							this.query[param] = this[key].map(s => s.s)
						} else if (key === 'locationText') {
							this.query[param] = this[key]
							if(!this.provinceSelected) {
								// this.query[param] = this[key]
								if (this.locationQueryText.type) {
									this.query['type'] = this.locationQueryText.type
								} else {
									delete this.query['type']
								}
							} else {
								// delete this.query[param]
								delete this.query['type']
							}
						} else if (key === 'useForVal') {
							if (this[key] === 'ALL') {
								delete this.query[param]
								if (this.useForSelected.length > 0 && this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length)) {
									this.query['market_selected'] = this.useForSelected
								} else {
									delete this.query['market_selected']
								}
							} else  {
								delete this.query['market_selected']
								this.query[param] = this[key]
							}
						} else {
							this.query[param] = this[key]
						}
					}
				} else {
					delete this.query[param]
					if (key === 'locationText') {
						delete this.query['type']
					}
				}
			}

			// Remove old paging for new search
			delete this.query['page']
			if (this.query['order'] === undefined) {
				delete this.query['order']
			}

			// this.clearCiteria()

			this.searching = true
			this.$router.push({
				path: this.$route.path === '/map-search' ? '/map-search' : this.$route.path === '/promotion' ? '/promotion' : '/search',
				// path: ['/recommend','/value','/promising','/luxury','/commercial'].includes(this.$route.path) ? this.$route.path : '/search',
				query: this.query
			}).catch(() => {})
				.finally(() => {
					// this.initCriteria({ ...this.query })
				})
		},

		toggleSearch (event) {
			event.preventDefault()
			let rect = document.querySelector('.v-toolbar__content').getBoundingClientRect()
			this.searchActive = false
			this.widgetY = rect.bottom
			if (this.widgetWidth === '100%') {
				this.widgetX = 0
			} else {
				this.widgetX = (rect.width - this.widgetWidth) / 2
			}
			this.$nextTick(() => {
				this.searchActive = true
			})
		},

		locationInputQuery () {
			this.provinceSelected = null
			this.districtSelected = null
			this.subDistrictSelected = null
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1

			this.locationTextChange()
		},

		locationShow (event) {
			event.preventDefault()
			let rect = this.$refs.locationBtn.$el.getBoundingClientRect()
			this.locationActive = false
			this.locationX = rect.left
			this.locationY = rect.bottom
			this.$nextTick(() => {
				this.locationActive = true
			})
		},

		provinceClicked (province) {
			// Clear query search items
			this.locationAcItems = []

			this.provinceSelected = province

			if(province === null) {
				this.useLocation = false
				this.locationStep = 1
			} else {
				this.useLocation = true
				this.locationStep = 2
			}

			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationTextChange()
		},

		districtClicked (district) {
			if(district !== null) {
				let index = this.districtSelected.indexOf(district)
				if (index < 0) {
					this.districtSelected.push(district)
				} else {
					this.districtSelected.splice(index, 1)
					for (let sd of district.v) {
						index = this.subDistrictSelected.indexOf(sd)
						if (index > -1) {
							this.subDistrictSelected.splice(index, 1)
						}
					}
				}

				this.useLocation = true
			} else {
				this.subDistrictSelected = []
				this.districtSelected = []
				this.locationActive = false
			}

			this.locationTextChange()
		},

		subDistrictClicked (subDistrict) {
			let index = this.subDistrictSelected.indexOf(subDistrict)
			if(index < 0) {
				this.subDistrictSelected.push(subDistrict)
			} else {
				this.subDistrictSelected.splice(index, 1)
			}
			this.useLocation = true
			this.locationTextChange()
		},

		locationTextChange () {
			// this.locationText = (this.provinceSelected ? this.provinceSelected.n : '') + (this.districtSelected ? ', ' + this.districtSelected.n : '')
			//this.locationQueryText = (this.provinceSelected ? this.provinceSelected.n : '')
			this.refLocationText = (this.provinceSelected ? this.provinceSelected.n : '')
			for(let d of this.districtSelected) {
				// this.locationQueryText += ', ' + d.n
				this.refLocationText += ', ' + d.n
			}
			for(let sd of this.subDistrictSelected) {
				// this.locationText += ', ' + sd.n
				// this.locationQueryText += ', ' + sd.n
				this.refLocationText += ', ' + sd.n
			}
			if (!this.refLocationText) {
				this.refLocationText = 'ทุกจังหวัด'
			}
		},

		useForShow (event) {
			event.preventDefault()
			let rect = this.$refs.useForBtn.$el.getBoundingClientRect()
			this.useForActive = false
			this.useForX = rect.left
			this.useForY = rect.bottom
			this.$nextTick(() => {
				this.useForActive = true
			})
		},

		priceShow (event) {
			event.preventDefault()
			let rect = this.$refs.priceBtn.$el.getBoundingClientRect()
			this.priceActive = false
			this.priceX = rect.left
			this.priceY = rect.bottom
			this.$nextTick(() => {
				this.priceActive = true
			})
		},

		numberOptionChanged (min, max, ref) {
			if(this[ref] > max) {
				this[ref] = max
			} else if (this[ref] < min) {
				this[ref] = ''
			}
		},

		clearCiteria () {
			this.garageCount = ''
			this.bedroomCount = ''
			this.toiletCount = ''
			this.floor = ''

			/**
			 * Location options
			 */
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1
			this.provinceSelected = null
			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationText = ''
			this.refLocationText = 'ทุกจังหวัด'

			this.locationQueryText = ''

			/**
			 * Property tx options
			 */
			this.txOptionSelected = 'BUY'

			/**
			 * 'Use for' options
			 */
			this.useForActive = false
			this.useForTab = 'ALL'
			this.useForVal = 'ALL'
			this.useForSelected = [
				// ...this.useForRestItems.map(item => item.value),
				// ...this.useForCommercialItems.map(item => item.value)
			]

			/**
			 * Price options
			 */
			this.hideMinPrice = false
			this.priceActive = false
			this.priceMin = ''
			this.priceMax = ''

			/**
			 * More filter: Announce time
			 */
			this.announceTimeSelected = null

			/**
			 * More filter: Useful space size
			 */
			this.hideMinUseful = false
			this.usefulSpaceActive = false
			this.usefulSpaceMin = ''
			this.usefulSpaceMax = ''

			/**
			 * More filter: Area space size
			 */
			this.hideMinArea = false
			this.areaSpaceActive = false
			this.areaSpaceMin = ''
			this.areaSpaceMax = ''

			/**
			 * More filter: Property direction
			 */
			this.propertyDirectionSelected = null

			/**
			 * More filter: Created date
			 */
			this.datePick = null
		}
	}
}
</script>

<style lang="scss" scoped>
.red-bottom-border {
	border-bottom: solid rgb(237,28,36);
}
.v-menu__content ::v-deep {
	// position: fixed;
	border-radius: 0;

	.v-card {
		border-radius: 0;
	}
	.v-input__slot {
		border-radius: 0;
	}
}
.v-item-group {
	&.v-btn-toggle {
		width: 100%;
	}

	& > :not(.v-item--active) {
		box-shadow: inset 0px 0px 5px #bbb;
	}
}
.v-item--active::v-deep {
	background-color: #fff;
	.v-btn__content, .v-list-item__content {
		color: rgb(237,28,36);
	}
}
.search {
	padding: 20px 40px 25px 40px;

	.close-search {
		position: absolute;
    top: 0;
    right: 0px;
    width: 30px;
		height: 30px;

		i {
			font-size: 16px;
		}
	}
	& > .row > .col {
		padding-bottom: 10px;
	}
	.btnSubmit {
		background: #fff;
		border-bottom-right-radius: 7px;
		border-top-right-radius: 7px;
		height: 36px;
		padding-top: 3px;
		text-align: center;
		width: 100%;
		button {
			background: #c20000;
			border-radius: 50%;
			color: #fff;
			height: 30px;
			text-align: center;
			width: 30px;
		}
		i {
			color: #fff;
		}
	}
	&::v-deep .v-input__slot {
		// border-radius: 0;
		margin-bottom: 0;
		min-height: auto;
	}
	.v-select__selections {
		height: 36px;
	}
	&::v-deep .v-text-field__details {
		display: none;
	}
	&::v-deep .v-text-field.v-text-field--solo .v-input__control {
		min-height: auto;
	}
	.v-text-field.v-text-field--solo .v-label {
		left: 15px !important;
	}
	.v-text-field.v-text-field--enclosed .v-text-field__details,
	.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
		padding: 0;
	}
}

.v-input--selection-controls {
	margin-top: 0;
}

.v-list-item__content::v-deep .highlight {
	color: red;
}

.location-text-field::v-deep .v-input__slot {
	border: solid 1px rgba(0,0,0,0.24);
	border-radius: 0;
	// border-left: none;
	// border-top-left-radius: 0;
	// border-bottom-left-radius: 0;
	display: inline-block !important;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;

	input {
		min-height: 44px;
	}
}
.location-select {
	border-top-left-radius: 7px;
	border-bottom-left-radius: 7px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-right: 0;
}
.location-select i {
	transform: rotate(-50deg);
}
.location-select-panel {
	width: 300px;
	max-height: 450px;
	overflow-y: auto;
}
.location-selected {
	background-color: #c20000;
	color: #fff;

	&::v-deep label {
		color: #fff !important;
	}
}
.province-panel, .district-panel {
	padding-left: 10px;
	line-height: 34px;

	&:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	&::v-deep label {
		color: #000;
	}
}
.sub-district-panel {
	margin-left: 19px;

	.location-options:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	input[type="checkbox"] {
		margin-right: 4px;
	}
}
.price-options {
	max-height: 300px;
	overflow-y: auto;
}
.input-center::v-deep input {
	text-align: center !important;
}
.btn-menu {
	border-color: rgba(0,0,0,0.24);
}
.btn-menu::v-deep .v-btn__content {
	display: inline-block !important;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;

	:not(.v-icon) {
		font-size: 1rem;
	}
}
.bgGrey {
	background: #eee;
}
</style>
